/**
* 顶部菜单
*/
<template>
  <div>
    <!-- Home顶部功能区域 -->
    <div class="site-nav" id="site-nav">
      <div class="w w1200">
        <ul class="quick-menu fl">
          <li>
            <div class="dt">
              <!-- <a href="/login" v-if="userInfo.loginName==null?true:false">登录</a> -->
              <router-link
                to="/login"
                v-if="userInfo.loginName == null ? true : false"
                >登录</router-link
              >
              <!-- <a  v-if="userInfo.userName==null?false:true">{{userInfo.userName}}</a> -->
            </div>
            <el-dropdown>
              <span class="el-dropdown-link" style="cursor: pointer;font-size:12px">
                <a v-if="userInfo.userName == null ? false : true">您好，{{!nickname?userName:nickname}}</a></span
              >
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  ><a href="javaScript:;" @click="rollOut"
                    >退出</a
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li
            v-if="userInfo.loginName == null ? true : false"
            class="spacer"
          ></li>
          <li>
            <div class="dt">
              <!-- <a href="/register" v-if="userInfo.loginName==null?true:false">注册</a> -->
              <router-link
                to="/register"
                v-if="userInfo.loginName == null ? true : false"
                >注册</router-link
              >
            </div>
          </li>

          <!-- 登录后再显示 (然后再判断显示哪个入口) -->
          <li class="spacer" v-if="userType == 1"></li>
          <li>
            <!-- <div class="dt" v-if="userInfo.type==1 && isUpStar!=3"> -->
            <div class="dt" v-if="userType == 1">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link" style="color:#D9D9D9;font-size:12px;line-height: 0px;">
                  账号认证<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <div v-if="isUp == null">
                  <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="企业认证"
                    >企业认证</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="电工认证"
                    >电工认证</el-dropdown-item
                  >
                  </el-dropdown-menu>
                </div>
                <div v-else>
                  <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item
                    command="企业认证"
                    v-if="isUp.type==2 || isUp.type==1"
                    >企业认证</el-dropdown-item
                  > -->
                   <el-dropdown-item
                    command="企业认证"
                    v-if="isUp.type == 2 && isUp.status != 3"
                    >企业认证</el-dropdown-item
                  >
                  <!-- <el-dropdown-item
                    command="电工认证"
                    v-if="isUp.type==3 || isUp.type==1"
                    >电工认证</el-dropdown-item
                  > -->
                   <el-dropdown-item
                    command="电工认证"
                    v-if="isUp.type == 3 && isUp.status !=3"
                    >电工认证</el-dropdown-item
                  >
                  </el-dropdown-menu>
                </div>


              </el-dropdown>
            </div>
          </li>
          <li class="li_dorpdown">
            <el-image
              :src='`${$imageUrl}/pcImages/images/homeTel.png`'
              fit="cover"
              style="width: 10px;height: 10px;margin:0 5px 0 10px;"
            >
            </el-image> {{informations.consumerHotline}}</li>

        </ul>

        <ul class="quick-menu fr">

          <li>
            <div class="dt">
              <router-link :to="userInfo.loginName == null ? '/login' : '/cashOnDelivery'">我的订单</router-link>
            </div>
          </li>
          <li class="spacer"></li>
          <li v-if="false">
            <div class="dt">
              <router-link :to="userInfo.loginName == null ? '/login' : '/cashInquirySheet'">我的询价单</router-link>
            </div>
          </li>
          <li class="spacer" v-if="false"></li>

          <li>
            <div class="dt">

              <router-link :to="userInfo.loginName == null ? '/login' : '/goodsCollection?name=我的收藏'">我的收藏</router-link>
            </div>
          </li>
          <li class="spacer"></li>
          <li>
            <div class="dt">
             <router-link :to="jummpurl"> 商家入驻</router-link>
            </div>
          </li>
          <!-- <li class="spacer" v-if="isUpStar==3 && isUp.type==2"></li> -->
          <li class="spacer" v-if="sjzxstatus"></li>
          <li>
            <div class="dt" v-if="sjzxstatus">
              <a :href="$baseUrl" target="_blank">商家中心</a>
            </div>
          </li>

          <li class="spacer"></li>
          <li>
            <div class="dt">
             <router-link to="/contact"> 联系我们</router-link>
            </div>
          </li>
          <li class="spacer"></li>
          <li class="li_dorpdown">
            <div class="dt">
              <!-- 原App下载 -->
              <a
              ref="appDownloud"
                href="javascript:;"
                @mouseenter="showapp = !showapp"
                @mouseleave="showapp = !showapp"
                @click="goappdown"
                style="display: flex;align-items: center;"
                >
                <el-image
                  :src='`${$imageUrl}/pcImages/images/homePhone.png`'
                  fit="cover"
                  style="width: 10px;height: 11px;margin-right: 5px;"
                >
                </el-image>
                手机云赢
              </a>
            </div>
            <!-- 隐藏区域 -->
            <transition name="el-zoom-in-top">
              <div
                v-show="showapp"
                class="dropdown-menu"

                style="
                  z-index: 10000000;
                  position: absolute;
                  background: rgba(255, 255, 255,1);
                  width: 250px;
                  height: auto;
                  color: rgb(18, 18, 18);
                "
                :style="{right:'-'+downloudPopRight+'px'}"
              >
              <div class="appdown">
                <div class="weixin">
                  <img class="ioscode" src="../assets/appdownicon/wechatcode1.jpg" />
                  <div class="iostitle">
                    <div style="padding-top: 5px;">扫一扫，登录小程序</div>
                    <img style="width: 25px;height: 25px;" src="../assets/appdownicon/weixinicon.png" />
                  </div>
                </div>
                <div class="iosapp">
                  <img class="ioscode" :src="iosappcode" />
                  <div class="iostitle">
                     <div style="padding-top: 5px;">扫一扫，下载ios端</div>
                    <img style="width: 25px;height: 25px;" src="../assets/appdownicon/iosapp.png" />
                  </div>
                </div>
                <div class="androidapp">
                   <img class="ioscode" :src="androidappcode" />
                  <div class="iostitle">
                    <div style="padding-top: 5px;">扫一扫，下载安卓端</div>
                    <img style="width: 25px;height: 25px;" src="../assets/appdownicon/androidapp.png" />
                  </div>
                </div>
              </div>
              </div>

            </transition>
          </li>
          <li>

          </li>
        </ul>
      </div>
    </div>
    <div style="background-color: #fff; width: 100%" v-if="isShowNavCenter">
      <!-- logo+收索 -->
      <div class="w w1200" style="background-color: #fff">
        <el-row class="logotop" type="flex" justify="center" align="top">
          <el-col :span="6">
            <div class="fl">
              <!-- <el-image
              style="cursor: pointer;"
                @click="$router.push('/')"
                class="logo"
                src='https://zhengtaiproductfile.oss-cn-hangzhou.aliyuncs.com/pcImages/images/logo.png'
                fit="fill"
              > -->
                 <el-image
              style="cursor: pointer;"
                @click="$router.push('/')"
                class="logo"
                :src="homelogo"
                fit="fill"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <!-- <el-image
              src='https://zhengtaiproductfile.oss-cn-hangzhou.aliyuncs.com/pcImages/images/ecsc-join.gif'
              fit="fill"
              style="border-radius: 5px"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image> -->
            </div>
          </el-col>
          <el-col :span="11">
            <div class="grid-content bg-purple">
              <div class="div-width">
                <el-dropdown @command="handleCommand1">
                  <span class="el-dropdown-link">
                    {{ name }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="商品">商品</el-dropdown-item>
                    <el-dropdown-item command="编码">编码</el-dropdown-item>
                    <el-dropdown-item command="店铺">店铺</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-input
                  class="input-width"
                  :placeholder="hotSearchList[0]"
                  v-model="searchInput"
                  @keyup.enter.native="getSearchClick('')"
                >
                </el-input>
                  <el-image
                      :src='`${$imageUrl}/icon_camera1778468257403.png`' @click="showImage = true"
                      style="width: 20px;margin-right: 12px;margin-bottom: -3px;"
                  ></el-image>
                <el-button
                  class="button-style"
                  slot="append"
                  @click="getSearchClick('')"
                >搜索</el-button>
              </div>
              <!-- 鼠标获取的 -->
              <!-- <div class="changeclass" v-if="falge">
                <div @click="changeshangp">商品</div>
                <div @click="changestore">店铺</div>
              </div> -->
            </div>
            <div style="margin-top: 5px; text-align: left">
              <span v-for="(item, index) in hotSearchList" :key="index">
                <!-- <router-link :to="`/goodsList?adWord=${item}`">{{item}}</router-link> -->
                <span @click="getSearchClick(item)" class="link">{{
                  item
                }}</span>
                <el-divider direction="vertical" v-if="hotSearchList.length-index!=1"></el-divider>
              </span>
            </div>
          </el-col>
          <el-col :span="7" style="text-align: right">
            <div class="grid-content shopgoodsCar">
              <el-button slot="reference" class="shopgoods" @click="remind(0)"
                  >
                  <el-image
                  :src='`${$imageUrl}/pcImages/images/shopCardIcon1.png`'
                  style="width: 20px;margin-right: 5px;margin-bottom: -3px;"
                  >
                </el-image>  购物车
                 <span v-if="list.length>0">{{list.length}}</span>
                </el-button>
                <!--<el-button slot="reference" class="shopgoods" @click="remind(1)"-->
                  <!--&gt;-->
                  <!--<el-image-->
                  <!--:src='`${$imageUrl}/pcImages/images/xunjialan.png`'-->
                  <!--style="width: 20px;margin-right: 5px;margin-bottom: -3px;"-->
                <!--&gt;-->
                <!--</el-image> -->
                <!--询价篮 -->
                 <!--<span v-if="inquiryList.length>0">{{inquiryList.length}}</span>-->
                <!--</el-button>-->


              <el-button slot="reference" class="shopgoods" @click="remind(2)"
              >
              <el-image
              :src='`${$imageUrlNew}/20250425-1043441745549061872.png`'
              style="width: 20px;margin-right: 5px;margin-bottom: -3px;"
              >
              </el-image>
              批量下单
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 顶部菜单 -->
    <div style="background-color: #fff; width: 100%">
      <div class="w w1200" v-if="isShowNav">
        <div class="categorys">
          <div
            class="categorys-type"
           @mouseenter="mouseenterBox"
           @mouseleave="mouseLeaveBox"
          >
            <a href="javascript:;"><i class="el-icon-menu"></i> 全部商品分类</a>
          </div>
          <!-- 隐藏分类 -->
          <div
            class="categorys-tab-content"
            v-show="isShowCategoryList"
            @mouseleave="mouseLeaveBox"
          >
            <div class="categorys-items" id="cata-nav">
              <!-- 商品分类start -->
              <div
                class="categorys-item"
                v-for="(oneItem, index) in categoryList"
                :key="index + '_item'"
              >
                  <!-- 一级分类跳转 -->
                  <!-- <div class="item item-content" @click="routeToGoodsList(oneItem, 3 , oneItem)"> -->
                    <div class="item item-content">
                  <div
                    class="categorys-title"
                    style="display: flex; justify-content: space-between"
                  >
                    <strong>
                      <span class="oneClassfiy">{{
                        oneItem.name
                      }}</span>
                      <!-- <div class="twoClassfiy">
                        <span v-for="classfiyItem in oneItem.sub" :key="classfiyItem.bxscId">
                        {{ classfiyItem.name }}
                      </span>
                      </div> -->
                    </strong>
                  </div>
                  <i class="iconfont icon-ele"
                    ><img
                      :src='`${$imageUrl}/pcImages/images/icon/Arrow.png`'
                      style="vertical-align: baseline"
                  /></i>
                </div>
                <div class="categorys-items-layer">
                  <div class="cate-layer-con clearfix">
                    <div class="cate-layer-left">
                      <div class="cate_channel" v-for="(subItem, index1) in sub[index]" :key="index1 + 'sunItem'">
                        <!-- 二级分类跳转 -->
                        <!-- <span class="fenlei" @click="routeToGoodsList(subItem, 4, subItem)">{{ subItem.name }} <i class="el-icon-arrow-right" style="font-weight: bold;"></i> </span> -->
                        <span class="fenlei">{{ subItem.name }} <i class="el-icon-arrow-right" style="font-weight: bold;"></i> </span>
                        <div class="cete-details-one">
                          <span
                          class="catedetails"
                          v-for="(itemchildren, indexchildren) in subItem.sub"
                          :key="indexchildren + 'childrenItem'"
                          @click="routeToGoodsList(itemchildren, 4, itemchildren)"
                          >{{ itemchildren.name}}</span
                        >
                        </div>
                      </div>
                    </div>
                    <div v-if="oneItem.length == 0 ? true : false" class="nodataCss">
                      <p>暂无相关分类数据</p>
                    </div>
                  </div>
                </div>
                <div class="clear"></div>
              </div>
                <!-- <div class="projectcase">
                  <img style="cursor: pointer;" @click="$router.push('/projectcasebg')" class="projectcasebg" :src="`${$imageUrl}/pcImages/projectcase/projectcasebg.png`" alt="">
                </div> -->
            </div>
          </div>
        </div>
        <div class="nav-main">
          <!-- <a href=""><i class="fa fa-bars"></i> 全部商品分类</a> -->
          <el-menu
            :default-active="$route.path"
            class="el-menu-demo"
            mode="horizontal"
            router
            @select="handleSelect"
          >
            <!-- navUrl -->
            <template v-for="(item, index) in navList">
              <el-menu-item :index="item.navUrl" :key="index + '_nav'">
                <i>
                  {{ item.navTitle }}
                </i>
              </el-menu-item>
            </template>
          </el-menu>
        </div>
      </div>
      <!-- <div class="nav-main">
        <el-menu
          :default-active="$route.path"
          class="el-menu-demo"
          mode="horizontal"
          router
          @select="handleSelect"
        >
          <template v-for="(item, index) in navList">
            <el-menu-item :index="item.navUrl" :key="index + '_nav'">
              <i>
                {{ item.navTitle}}
              </i>
            </el-menu-item>
          </template>
        </el-menu>
      </div> -->
      <!-- </div> -->
    </div>
      <searchImgUploadDialog v-if="showImage" @closeDialog="closeDialog"></searchImgUploadDialog>
  </div>
</template>
<script type="text/javascript" src="../assets/js/kuCity.js"></script>
<script>
import "@/assets/css/base.css";
import "@/assets/css/style.css";
import mainlayout from "../components/layout/mainlayout";
import searchImgUploadDialog from "../components/searchImgUploadDialog"
import {
  navList,
  shoppingCartlist,
  hot_search,
  search_list,
  setImage,
  frontCategory,
  getUserAccountApplyStatus,
  copyRight,
  userDetails,
  getUserInfo,
  getlogo,
  geqrcode,
  getqrcode,
  InquiryBasketList
} from "@/api/xunyou";
import { mapState, mapMutations } from "vuex";
import bus from "@/utils/bus"; //引入事件中心
export default {
  name: "leftnav",
  inject: ["reload"],
  data() {
    let self = this;
    return {
      downloudPopRight:0,
      homelogo:'',//首页logo
      jummpurl:'',
      currentrouter:'',
      falge: false,
      loading: false,
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {
        mallUser: {},
      },
      formInline: {
        pageSize: 10,
        currentPage: 1,
      },
      name: "商品",
      // input: "",
      // accountTotal:0,
      // goodsnum: 0,
      showapp: false, //app不显示
        showImage:false,
      appimg: "https://www.pgyer.com/app/qrcode/b6TU",
      showwx: false, //微信不显示
      show2: false, //默认进入不显示
      collapsed: false,
      allmenu: [],
      //  list:[], //购物车的数据
      //地图
      center: [121.59996, 31.197646],
      city: "全国",
      lng: 0,
      lat: 0,
      loaded: false,
      logo: this.$imageUrl+"/pcImages/images/logo.png",
      plugin: [
        {
          pName: "Geolocation",
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                if (result && result.position) {
                  self.$store.commit(
                    "gotCurrentAddress",
                    result.addressComponent
                  );
                  self.lng = result.position.lng;
                  self.lat = result.position.lat;
                  self.city =
                    result.addressComponent.city ||
                    result.addressComponent.district;
                  self.center = [self.lng, self.lat];
                  self.loaded = true;
                  self.$nextTick();
                }
              });
            },
          },
        },
      ],
      userMallStore:'',
      navList: [],
      activeIndex: "1",
      categoryList: [],
      sub: [],
      index: "",
      hotSearchList: [],
      searchInput: "",
      isShowCategoryList: false,
      // 当前账号的状态
      upgradeStatus: null,
      //操作过认证的类型 2企业 3电工
      userStatus: null,
      userType: null,
      informations:'',
      userName:'',
      isUpStar:'',
      isUp:[],
      sjzxstatus:false,
      weixincode:'',//存储微信二维码
      iosappcode:'',//存储ios二维码
      androidappcode:'',//存储安卓二维码
    };
  },
  // 注册组件
  components: {
    mainlayout,
      searchImgUploadDialog
  },
  computed: {
    ...mapState(["isShowNav", "list", "accountTotal", "totalNumber",'isShowNavCenter','nickname','inquiryList']),
  },
    // 创建完毕状态(里面是操作)
  created() {
    this.searchleftMenuList();
    if (this.userInfo.loginName) {
      this.getUserStatus();
    }
    this.getlogo()
        this.searchNavList();
        this.getcode()
        console.log(this.userInfo);
  },
  // 挂载结束状态(里面是操作)
  mounted() {
    let variable = this.$refs.appDownloud.getBoundingClientRect().right;
    let difference = 0;

    this.$nextTick(() =>{
    const screenWidth = this.$el.clientWidth;
    difference = screenWidth - variable
    if(difference>=0&&difference<=155){
      this.downloudPopRight = difference
    }else if(difference<0){
      this.downloudPopRight=0
    }else{
      this.downloudPopRight=155
    }
});
    this.userinfo()
    this.gethotSearch();
    this.getImagelogo();
    if(this.userInfo.mallUser.muid){
      this.getshoppingCartlist();
      this.getInquiryBasketList();
    }
    this.geTCopyright()
    this.getuserDetails()
    // console.log(this.isUp)
  },
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
      //closeDialog
      closeDialog(imgUrl,uploadLogId){
          this.showImage = false
          localStorage.setItem('searchImgUrl',imgUrl)
          localStorage.setItem('uploadLogId',uploadLogId)
          if(this.$route.path === '/searchImgQuery'){
              this.$router.go(0)
          }else{
              this.$router.push('/searchImgQuery')
          }

      },
    // 获取二维码
    getcode() {
      getqrcode().then((res) => {
          if (res.success == true ) {
            let data = res.data
            data.forEach(item => {
              if (item.head == 'android') {
                if (item.qrImage && item.qrImage.length>0) {
                    this.androidappcode = item.qrImage
                }
              }else if  (item.head == 'ios') {
                if (item.qrImage && item.qrImage.length>0) {
                    this.iosappcode = item.qrImage
                }
              }
            });
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    goappdown() {
      this.$router.push('/appdown')
    },
     async userinfo() {
         const res = await getUserInfo({username:this.userInfo.mallUser.username,muid:this.userInfo.mallUser.muid});
          // console.log(res);
          if (res.code == 0) {
            if (res.data.merchant) {
          // console.log(res);
          this.sjzxstatus = true
            }
          }
      },
      async getlogo() {
         const res = await getlogo();
          console.log(res);
          if (res.success == true) {
           this.homelogo = res.data.pcLogo
          }
      },
    remind(type){

      // this.$message({
      //     type: "success",
      //     duration:5000,
      //     message: "尊敬的用户您好：平台暂不支持在线支付，若您有任何订单需求可直接联系商家或平台，我们将竭诚为您提供服务。",
      //   });
       if (this.userInfo.mallUser.muid == undefined) {
        this.$message.error("请登录！");
        setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
        return;
      }

      if(type==0){ //购物车
        this.$router.push('/shoppingcart')
      }else if(type == 1){  //询价篮
        this.$router.push('/inquiryBasket')
      }else if(type == 2){ //批量下单
        this.$router.push('/batchOrder')
      }

    },
    // 查询账户信息
    getuserDetails() {
      const req ={
        userId:this.userInfo.mallUser.muid,

      }
      if(req.userId==undefined){
          this.jummpurl='/login'
      }else{
        this.jummpurl='/welcomesystem'
      }
      console.log(this.jummpurl);
      // console.log(this.jummpurl);
       //调个人中心接口
      userDetails(req)
        .then((res) => {
          if(res.code == 0){
            this.userName = res.data.nickname
          }
        })
    },

    // 获取客服电话
    geTCopyright(){
      copyRight().then(res=>{
        if(res.code==0){
          this.informations = res.rows[0]
        }
      }).catch(err=>{
        this.$message.error('查询失败,请稍后再试!')
      })
    },
    // 获取购物车
    getshoppingCartlist() {
      shoppingCartlist({ uid: this.userInfo.mallUser.muid || "" })
        .then((res) => {
          if (res.length > 0) {
            this.$store.commit("getCartList", res);
          }
        })
        .catch((err) => {
          this.$message.error("购物车查询失败，请稍后再试！");
        });
    },
    //获取询价篮
    getInquiryBasketList(){

        InquiryBasketList({
          id:this.userInfo.mallUser.muid
        }).then((res)=>{

          if(res.success){
            let inquiryList = []
            res.data.shopList.forEach((item)=>{
              item.voList.forEach((voListItme)=>{
                inquiryList.push(voListItme)

              })
            })
            this.$store.commit('getInquiryList',inquiryList)
          }else{
            console.log(res)
            this.$message.error(res.errorMessage)
          }
        }).catch((err)=>{
          this.$message.error(err.errorMessage)
        })
      },
    //搜索
    getSearchClick(name) {
      console.log(name,111111111)
      //当搜索的是商品时
      this.$store.commit('getPathSource',false)
      if (this.name === "商品" || this.name === "编码") {
        let path = this.$route.path;
        let val = "";
        if (name) {
          val = name;
          this.searchInput = name;
        } else {
          val =
            this.searchInput == "" ? this.hotSearchList[0] : this.searchInput;
        }
        if (!this.searchInput) {
          this.searchInput = this.hotSearchList[0];
        }
        if (path.includes("supplier")) {
          this.$router.push(`/goodsList_supplier?adWord=${val}`);
        } else {
            let stype = this.name === "商品" ? 2: 3
          this.$router.push({ name: "商品列表", params: { adWord: val,stype:stype}});

          bus.$emit("search", val,stype);
          // if (path != "/goodsList") {
          //   // this.$router.push(`/goodsList?adWord=${val}&type=search`);
          //   this.$router.push({ name: "商品列表", params: { adWord: val} });
          //   return;
          // } else {
          //   let params = JSON.parse(JSON.stringify(this.$route.params));
          //   params.adWord = val;
          //   // this.$router.replace({
          //   //   params,
          //   // });
          //   bus.$emit("search", val);
          // }
        }
      } else {
        //搜索的是店铺时
        if (this.name === "店铺") {
          let path = this.$route.path;
          let val = this.searchInput == "" ? "" : this.searchInput;
          if (path != "/store") {
            //其他页面,使用路由跳转
            this.$router.push("/store?name=" + val);
            return;
          } else {
            //不使用路由跳转
            bus.$emit("store", val);
          }
        }
      }
    },

    // 获取logo
    getImagelogo() {
      setImage().then((res) => {
        if (res.code == 0) {
          this.logo = res.rows[0].pcLogo;
        }
      });
    },
    // 鼠标移入移出
    mouseenterBox() {
      // if (this.$route.path == "/") {
        if (this.currentrouter!=='/'){
            this.isShowCategoryList = !this.isShowCategoryList;
        }

      // } else {
      //   this.isShowCategoryList = false;
      // }
    },
    // 鼠标移入移出
    mouseLeaveBox() {
      // if (this.$route.path == "/") {
      if (this.currentrouter!=='/'){
            this.isShowCategoryList = !this.isShowCategoryList;
        }
      // } else {
      //   this.isShowCategoryList = false;
      // }
    },
    // 退出登录
    rollOut() {
      localStorage.removeItem("userdata");
      this.$router.push("/login");
      // window.location.reload();
    },
    // 菜单
    searchNavList() {
      this.loading = true;
      navList()
        .then((res) => {
          if (res.code == 0) {
            this.loading = false;
            this.navList = res.data
            // console.log(  this.navList,'  this.navList  this.navList',this.userType)
            // debugger
              // if(this.userType!=2){

                // this.navList=res.data.filter((item)=>{
                //   if(item.navTitle!=="招商公告"){
                //     // item = ''
                //     console.log(item,'navListnavList')
                //     return this.navList = item
                //   }
                //   // return item.navTitle !=="招商公告"
                // })
              //   console.log(this.navList,'fffffffffffff',this.userType)
              // }else{
              //   this.navList = res.data
              // }

          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    // 左侧菜单
    searchleftMenuList() {
      this.loading = true;
      frontCategory({ parentBxscId: 0 })
        .then((res) => {
          if (res.code == 0) {
            this.loading = false;
            this.categoryList = res.data;
            console.log( this.categoryList,'分类列表');
            this.categoryList.map((el, index) => {
              this.sub.push(el.sub);
            });
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    handleSelect(key, keyPath) {
      console.log(key,keyPath)
      // if (this.$route.path == key) {
      //   this.reload();
      // }
      if (this.userType!=2){
        // this.$message({
        //   type: "info",
        //   message:'企业用户才可查看'
        // })
        if(key=="tender"){
          this.$message('企业用户才可查看')
        }

      }
    },
    // 热门搜索
    gethotSearch() {
      hot_search()
        .then((res) => {
          if (res.code == 0) {
            this.hotSearchList = res.data.column10.split(",");
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    // 默认搜索
    getSearchList() {
      search_list()
        .then((res) => {
          if (res.code == 0) {
            this.searchInput = res.rows[0].column1;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    //点击分类进入商品列表查询
    routeToGoodsList(val, level, item) {
      // 先判断当前页面是否是商品列表页面,是则事件中心传值，不是则路由传值
      let routeCurrent = this.$route;
      console.log(this.$route)
      console.log(this.isShowCategoryList)
      console.log(val,'分类列表1',item,'分类列表2')
      // 事件中心传值
      this.isShowCategoryList = false
      // this.mouseLeaveBox()
      this.$store.commit('getPathSource',true)
     setTimeout(()=>{
        if (routeCurrent.path === "/goodsList") {
        let obj = {};
        if (level === 3) {
          // obj = {
          //   parentBxscId: val.backIds,
          //   secondCategory: true,
          //   level: 3,
          // };
          this.$router.push(
            `/goodsList?parentBxscId=${val.backIds}&parentBxscIds=${val.bxscId}&secondCategory=true&level=3`
          );
          // console.log('xxxxxxxxx',obj)
        } else {
          // obj = {
          //   parentBxscId: val.backIds,
          //   parentBxscIds: item.bxscId,
          //   secondCategory: true,
          //   level: 4,
          // };
          this.$router.push(
            `/goodsList?parentBxscId=${val.backIds}&parentBxscIds=${item.bxscId}&secondCategory=true&level=4`
          );
          // console.log('ffffff',obj)
        }
        // bus.$emit("cate", obj);
      } else {
        // 路由传值
        if (level === 3) {
          this.$router.push(
            `/goodsList?parentBxscId=${val.backIds}&parentBxscIds=${val.bxscId}&secondCategory=true&level=3`
          );
        } else {
          this.$router.push(
            `/goodsList?parentBxscId=${val.backIds}&parentBxscIds=${item.bxscId}&secondCategory=true&level=4`
          );
        }
      }
     },100)
      // this.isShowCategoryList=false;
    },
    //升级事件
    handleCommand(val) {
      let str = val === "企业认证" ? 0 : 1;
      let type = val === "企业认证" ? 1 : 3;
      // let step = this.isUpStar ==0 ?1:3
      let step = ''
      if (this.isUpStar == 1) {
        step = this.isUpStar
      }else {
        step = this.isUpStar ==0 ?1:3
      }
      // let status = ''
      // if (this.isUp != null) {
      //   status = this.isUp.status
      // }
      // let step = ''
      // if (val === "企业认证") {
      //   if (this.isUp != null && this.isUp.type != 3) {
      //     step = 1
      //     this.upgradeStatus = 0
      //   }else {
      //     step = 3
      //   }
      // }else {
      //    if (this.isUp != null && this.isUp.type ==2 && this.isUp.status == 1) {
      //     step = 1
      //   }else {
      //     step = 3
      //   }
      // }

      this.$router.push(
        `/accountUpgrade?str=${str}&type=${type}&step=${step}&upgradeStatus=${this.upgradeStatus}`
      );

    },
    //获取当前账号状态(登录状态触发)
    async getUserStatus() {
      const res = await getUserAccountApplyStatus({
        muid: this.userInfo.mallUser.muid,
      });
      this.isUp = res.data.accountApplyInfo
      this.isUpStar = res.data.status
      if (res && res.data.status !== null) {
      // if (res.data.accountApplyInfo !== null) {
        //res下的status是当前账号是否升级过的状态(0是未升级，其他则是已操作过)
          this.userMallStore = 2
          this.userType = res.data.mallUser.type;
          console.log(this.userType)
          localStorage.setItem('userType',this.userType)
        if (res.data.status === 0) {
        // if (res.data.accountApplyInfo.status === 0) {
          // 未升级则把状态存入本地
          this.upgradeStatus = 0;
          if(res.data.accountApplyInfo==null){
            this.$store.commit("userStatusType", {
                type: res.data.mallUser.type,
                type1:res.data.accountApplyInfo
              });
          }
        } else {
          //升级过则会返回升级的状态,未通过(驳回)则存值且显示账号升级(结构) 1未通过 2待审核  3通过
          let status = res.data.accountApplyInfo.status;
          if (status == 1) {
            let type = res.data.accountApplyInfo.type === 2 ? "企业" : "电工";
            if (res.data.accountApplyInfo !== null) {
              this.userStatus = res.data.accountApplyInfo.type;
              this.userType = res.data.mallUser.type;

              this.$store.commit("userStatusType", {
                //当前用户的状态
                type: res.data.mallUser.type,
                 //上次认证记录的类型
                type1:res.data.accountApplyInfo.type,
                 //上次认证记录的状态 1未通过 2待审核  3通过
                status: res.data.accountApplyInfo.status,
              });
            }
            this.upgradeStatus = 1;
            console.log(type);
            if (type == '企业') {
            this.$message(`您的企业注册申请未通过审核，请在首页顶部的菜单“账号认证-企业认证”中重新提交资料申请`);
            }else {
            this.$message(`您的电工注册申请未通过审核，请在首页顶部的菜单“账号认证-电工认证”中重新提交资料申请`);
            }
          }
          if (status == 2) {
            this.userMallStore = 2
            this.$store.commit("userStatusType", {
              type: res.data.mallUser.type,
              type1:res.data.accountApplyInfo.type,
              status: res.data.accountApplyInfo.status,
            });
          }
          if (status == 3) {
            this.$store.commit("userStatusType", {
              type: res.data.mallUser.type,
              type1:res.data.accountApplyInfo.type,
              status: res.data.accountApplyInfo.status,
            });
          }
        }
        this.searchNavList();
      } else {
        this.upgradeStatus = null;
        this.userType = res.data.mallUser.type;
      }
    },
    //切换搜索关键词
    handleCommand1(val) {
      this.name = val;
    },
  },

  watch: {
    $route: {
      handler: function(route) {
        console.log(route)
        this.currentrouter=route.path
        // console.log(this.currentrouter)
        if(this.currentrouter=='/'){
          this.isShowCategoryList=true
        }else{
          this.isShowCategoryList=false
        }
        // console.log(this.isShowCategoryList)
      },
      immediate: true
    }
  },

};
</script>
<style lang="less" scoped>
.div-width {
  display: flex;
  align-items: center;
  width: 100%;
  height: 42px;
  border: 2px solid #237AE4;
}
.div-width .el-dropdown {
  width: 15%;
}
/deep/.el-input__inner {
  outline: none;
  border: none;
  height: 40px;
}
.input-width {
  outline: none;
  border: none;
  width: 70%;
}
.button-style {
  font-size: 18px;
    color: #fff;
    background-color: #237AE4;
    width: 19%;
    border: none;
    border-radius: 0;
    letter-spacing: 5px;
}
/deep/ .logo img {
  width: auto;
  height: auto;
}
.logotop {
  margin: 1rem 0;
}
/deep/.el-input-group__append {
  border-left: 0;
  background-color: #237AE4;
}
.el-input-group__append,
.el-input-group__prepend {
  background-color: #237AE4;
  color: white;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  border: 0px;
  border-radius: 4px;
  padding: 0 20px;
  width: 1px;
  white-space: nowrap;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
/* 购物车样式 */
button.el-button.shopgoods.el-button--default.el-popover__reference:hover {
  border: 1px solid #237AE4;
  color: #237AE4;
  background: #fff;
}
.shopgoodsCar{
  display: flex;
  justify-content: flex-end;
  .shopgoods{
  border-radius: 0;
  border:1px solid #237AE4;
  color:#237AE4;
  position: relative;
  height: 45.2px;
  font-size: 18px;
  width: 150px;
  span{
    color: #fff;
    width: 18px;
    height: 18px;
    display: inline-block;
    line-height: 18px;
    position: absolute;
    top: 3px;
    right: 12px;
    font-size: 10px;
    background-color: #ea675d;
    border-radius: 18px;
  }
}
}

/* top菜单 */
.categorys {
  float: left;
  width: 232px;
  height: 40px;
  position: relative;
}

.categorys-type {
  background-color: #237AE4;
  text-align: center;
  font-size: 0;
  line-height: 40px;
}

.categorys-type a {
  font-size: 17px;
  font-weight: 700;
  color: #fff;
  display: block;
}

.nav-main {
  float: left;
  width: 968px;
  overflow: hidden;
  height: 40px;
  line-height: 40px;
}

.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 40px;
  line-height: 40px;
  margin: 0;
  border-bottom: 2px solid transparent;
  color: #909399;
  i{
    color: #040000;
    font-size: 17px;
  }
}

/deep/.el-menu--horizontal > .el-menu-item.is-active {
  color: #237AE4 !important;
  font-weight: bold;
  i{
    color: #237AE4 !important;
  }
}

/* 分类表 */
.categorys-tab-content {
  height: auto !important;
  // padding: 15px 0;
  padding-top: 15px;
  padding-bottom: 10px;
  box-sizing: border-box;
  z-index: 30;
  // background-color: #000;
  background-color:#fff;
  // background-color: #237AE4;
  // opacity: 0.6;
  /* bingo */
  display: block;
  position: relative;
}

.categorys-tab-content .categorys-items {
  position: relative;
  height: 100%;
}

.categorys-tab-content .categorys-item {
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: auto;
}

.categorys-tab-content .item-content {
  padding: 5px 16px;
  display: flex;
  width: 200px;
  justify-content: space-between;
  align-content: center;
  height: 95%;
  // align-items: center;
}
.categorys-tab-content .item-content:hover{
    background: #E6EFF7;
    border-left: 2px solid #237AE4;
    padding: 5px 14px;
}
.categorys-tab-content .item-content .icon-other {
  float: left;
  width: 18px;
  height: 18px;
}

.categorys-tab-content .item-content .icon-other img {
  width: 100%;
}

.categorys-tab-content .selected .item-content {
  background-color: rgba(0, 0, 0, 1);
}

.categorys-tab-content .iconfont {
  float: left;
  color: #bfbfbf;
  display: flex;
  align-items: center;
}

.categorys-tab-content .categorys-title {
  float: left;
  margin-left: 10px;
  text-align: left;
}

.categorys-tab-content .categorys-title strong {
  font-weight: normal;
  display: flex;
  // align-items: center;
  flex-direction: column;
  justify-content: center;
}

.categorys-tab-content .categorys-title strong span {
  color: #545555;
  font-size: 12px;
}
.categorys-tab-content .categorys-title strong span.oneClassfiy{
  font-size: 17px;
  color: #040000;
}
.categorys-tab-content .categorys-title strong .twoClassfiy{
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  span{
    margin-right: 10px;
    margin-top: 5px;
  }
}
.categorys-tab-content .categorys-title span {
  display: block;
  font-size: 0;
}

.categorys-tab-content .categorys-title span a {
  color: #bfbfbf;
  margin-right: 10px;
  font-size: 14px;
}

.categorys-tab-content .categorys-title span a:hover,
.categorys-tab-content .categorys-title strong a:hover {
  color: #237AE4;
}

.categorys-items-layer {
  display: none;
  position: absolute;
  top: -15px;
  left: 232px;
  min-height: 464px;
  border: 2px solid #237AE4;
  width: 715px;
  background-color: #fff;
  box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.1);
  -webkit-transition: top 0.25s ease;
  transition: top 0.25s ease;
  max-height: 100%;
  overflow: auto;
  overflow-x: hidden;
  .nodataCss {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
  }
}

/* 购物车的样式 */
.cartTip {
  .cartBox.el-row {
    margin: 15px;
    // background: red;
    height: 80px;
    .el-image.cartgoodsPhotos {
      height: 80px;
      width: 100%;
      position: inherit;
    }
    .cartHeight {
      height: 80px;
      line-height: 80px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .cartHeight_total {
    font-size: 18px;
    padding: 0 20px;
    color: #237AE4;
    .totalNum {
      font-size: 14px;
      color: #000;
    }
  }
  .cartHeight_cart {
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: #237AE4;
    color: white;
    font-size: 15px;
    a.router-link-exact-active.router-link-active {
      color: white;
    }
  }
}
.link {
  cursor: pointer;
  &:hover {
    color: #237AE4;
  }
}
// .cate_channel {
//   width: 100%;
//   border: 1px solid transparent;
// }
.cate_channel {
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  overflow: hidden;
}
.fenlei {
  // flex: 1;
  // width: 100px;
  cursor: auto;
  width: 15%;
  overflow: hidden;
  text-align: right;
  line-height: 24px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.cete-details-one {
  display: flex;
  flex-wrap: wrap;
  width: 85%;
}
.cate_channel .catedetails {
  cursor: pointer;
  display: inline-block;
  float: left;
  margin-right: 10px;
  height: 24px;
  padding: 0 10px 0 12px;
  // background-color: #5f4f4f;
  color: #000;
  line-height: 24px;
  // margin-bottom: 5px;
  &:hover{
    color: #237AE4;
  }
}
.el-icon-mobile-phone:before{
  content: "";
  background: url(https://zhengtaiproductfile.oss-cn-hangzhou.aliyuncs.com/pcImages/images/icon/phone.png) no-repeat;
    background-size: 100% 100%;
    width: 8px;
    height: 12px;
    display: block;
}
.headl{
  float: none;
}
.iconfont img{
  width: 15px;
  height: 15px;
}
.appdown {
  padding: 10px;
}
.iosapp,.weixin {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #eee;
  padding: 5px 0px;
}
.androidapp {
  display: flex;
  flex-wrap: wrap;
  padding: 5px 0px;
}
.ioscode {
  width: 100px;
  height: 100px;
  // background-color: #237AE4;
}
.iostitle {
  font-size: 12px;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
}

.projectcase {
  margin-top: 12px;
  width: 100%;
  height: 124.5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.projectcasebg {
  width: 210px;
  height: auto;
}
/deep/.el-dropdown{
  color: #040000;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/topnav.vue